module.exports = __webpack_public_path__ + "static/media/4.c6a688f9.JPG";